import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { takeReturnPath } from '../utils/returnPath';

/**
 * SSO always comes back to the start page. A link that needed the login, such as one from an
 * email, opens from there.
 */
export const useReturnAfterLogin = (isLoggedIn: boolean): void => {
  const navigate = useNavigate();
  useEffect(() => {
    if (!isLoggedIn) return;
    const back = takeReturnPath();
    if (back) navigate(back, { replace: true });
  }, [isLoggedIn, navigate]);
};
